import AppleSelect from './AppleSelect';

// Labelled AppleSelect over a list of {id, name} items
const FormListbox = ({
                         label,
                         options,
                         value,
                         onChange,
                         error,
                         placeholder = "Sélectionner une option",
                         required = false,
                         displayValue = (item) => item?.name || "",
                         optionRender = (item) => item?.name || "",
                         labelAction = null,
                     }) => {
    const items = Array.isArray(options) ? options : [];
    return (
        <div>
            {(label || labelAction) && (
                <div className="flex items-center justify-between mb-1">
                    <label className="text-sm font-medium text-gray-700 dark:text-gray-300 block">
                        {label} {required && <span className="text-red-500">*</span>}
                    </label>
                    {labelAction}
                </div>
            )}
            <AppleSelect
                aria-label={label || placeholder}
                value={value ?? ""}
                onChange={(e) => onChange(items.find(item => String(item.id) === e.target.value)?.id || "")}
                error={!!error}
                placeholder={placeholder}
                options={items.map(item => ({value: item.id, label: optionRender(item), display: displayValue(item)}))}
            />
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        </div>
    );
};

export default FormListbox;
